const notifications = {
  subscriptionSuccess: 'Subscrito a notificaciones correctamente',
  unsubscriptionError: 'Error thrown while revoking push notifications. Most likely because push was never registered',
  unsubscriptionSuccess: 'Subscripción a notificaciones cancelada',
};
export default notifications;
